(function() {

  // Alle Elemente zentral cachen (vermeidet ständiges Suchen im DOM)
  const header = document.querySelector('.nxa-component-header');
  const headerInner = document.querySelector('.nxa-component-header-inner');

  // Abbruch, wenn Header nicht existiert
  if (!header || !headerInner) return;

  const logo = header.querySelector('.logo');
  const backBtn = header.querySelector('button.back');
  const mainMenuToggle = header.querySelector('.main-menu-toggle');
  const mainMenuContainer = document.querySelector('.main-menu-container');
  const mainMenu = document.querySelector('nav.main-menu');
  const desktopMenuMediaQuery = window.matchMedia('(min-width: 992px)');
  let mainMenuHeightObserver = null;
  let currentlyOpenSubmenu = null;

  // Language Menu Elemente
  const langMenu = mainMenuContainer.querySelector('.language-menu');
  const langBtn = langMenu ? langMenu.querySelector('button') : null;
  const langLi = langMenu ? langMenu.querySelector('nav li:not(.wpml-ls-current-language)') : null;
  const langLink = langLi ? langLi.querySelector('a') : null;

  // Submenü Trigger Buttons
  const submenuButtons = document.querySelectorAll('nav.main-menu > ul > li > button');

  // State Variablen
  let scrollBlocked = true;
  let lastScroll = null;
  let ticking = false;

  // Helper Funktionen für UI-Logik

  // Schaltet zwischen "Hauptansicht" und "Submenü-Ansicht" um
  function toggleSubmenuMode(isActive) {
    if (logo) logo.classList.toggle('is-not-visible', isActive);
    if (backBtn) backBtn.classList.toggle('is-visible', isActive);
  }

  // Schließt alle offenen Submenüs und setzt die Ansicht zurück
  function resetSubmenus() {
    const openSubmenus = mainMenuContainer.querySelectorAll('ul.is-open');
    openSubmenus.forEach(el => el.classList.remove('is-open'));
    toggleSubmenuMode(false);
  }

  function setMainMenuState(isOpen) {
    mainMenuToggle.setAttribute('aria-expanded', isOpen);
    mainMenuContainer.classList.toggle('is-open', isOpen);

    if (!isOpen) {
      closeLanguageMenu();
      resetSubmenus();
      return;
    }

    if (!desktopMenuMediaQuery.matches) return;

    const button = mainMenu.querySelector('li.current-menu-parent button') ||
      mainMenu.querySelector('ul > li > button');

    button?.click();
  }

  function openLanguageMenu() {
    if (langLi && langLink) {
      langLi.style.transition = 'width 0.3s ease-in-out';
      langLi.style.width = langLink.offsetWidth + 'px';
      const isFirst = !langLi.previousElementSibling;
      langLi.style.paddingLeft  = isFirst ? '0px' : '5px';
      langLi.style.paddingRight = isFirst ? '5px' : '0px';
    }
  }

  function closeLanguageMenu() {
    if (langLi) {
      langLi.style.transition = 'width 0.3s ease-in-out, padding 0.2s ease-in-out .2s';
      langLi.style.width = '0px';
      langLi.style.paddingLeft  = '0px';
      langLi.style.paddingRight = '0px';
    }
  }

  // Scroll Logic
  function handleScroll() {

    const currentScroll = window.scrollY;

    // Safari-Bounce-Schutz: Im negativen Bereich nichts tun
    if (currentScroll < 0) {
      ticking = false;
      return;
    }

    // Safe-Zone: Ganz (oder fast ganz) oben: Header immer zeigen
    if (currentScroll <= 50) {
      headerInner.classList.remove('offscreen');
      lastScroll = currentScroll;
      ticking = false;
      return;
    }

    if (lastScroll !== null) {
      // Threshold: Nur reagieren, wenn die Differenz größer als der Schwellenwert (10) ist
      const scrollDiff = Math.abs(currentScroll - lastScroll);
      if (scrollDiff > 10) {
        const isScrollingDown = currentScroll > lastScroll;
        headerInner.classList.toggle('offscreen', isScrollingDown);
        // Das Hauptmenü schließen beim Runterscrollen
        if (isScrollingDown) {
          setMainMenuState(false);
        }
        // lastScroll nur aktualisieren, wenn der Threshold überschritten ist (kein Aufsummieren kleiner Bewegungen)
        lastScroll = currentScroll;
      }
    } else {
      lastScroll = currentScroll;
    }
    ticking = false;
  }

  function requestTick() {
    if (!scrollBlocked && !ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  // Logik zur Synchronisierung der Menühöhe mit dem Untermenü
  function startMainMenuHeightSync(subUl) {
    if (!subUl) return;

    stopMainMenuHeightSync();

    mainMenuHeightObserver = new ResizeObserver(entries => {
      const { height } = entries[0].contentRect;
      mainMenu.style.minHeight = `${height + 24 + 4}px`;
    });

    mainMenuHeightObserver.observe(subUl);
  }

  function stopMainMenuHeightSync() {
    if (mainMenuHeightObserver) {
      mainMenuHeightObserver.disconnect();
    }

    mainMenuHeightObserver = null;
    mainMenu.style.minHeight = '';
  }

  desktopMenuMediaQuery.addEventListener('change', e => {
    if (e.matches) {
      // Mobile → Desktop
      if (currentlyOpenSubmenu) {
        startMainMenuHeightSync(currentlyOpenSubmenu);
      }
    } else {
      // Desktop → Mobile
      stopMainMenuHeightSync();
    }
  });

  // Initialisierung
  window.addEventListener('scroll', requestTick, { passive: true });

  // Scroll-Blocker für Page-Load (verhindert Sprünge)
  document.documentElement.style.scrollBehavior = 'auto';
  setTimeout(() => {
    scrollBlocked = false;
    document.documentElement.style.scrollBehavior = '';
    if (!document.documentElement.getAttribute('style')) {
      document.documentElement.removeAttribute('style');
    }
  }, 100);

  // Event Listener

  // Hauptmenü Toggle
  mainMenuToggle.addEventListener('click', function() {
    const isCurrentlyOpen = this.getAttribute('aria-expanded') === 'true';
    setMainMenuState(!isCurrentlyOpen);
  });

  // Sprachmenü Toggle
  if (langBtn) {
    langBtn.addEventListener('click', function() {
      const isOpen = langLi.style.width && langLi.style.width !== '0px';
      isOpen ? closeLanguageMenu() : openLanguageMenu();
    });
  }

  // Submenüs öffnen
  submenuButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const parentUl = this.closest('ul');
      if (parentUl) {
      parentUl.querySelectorAll('ul.is-open').forEach(subUl => {
        subUl.classList.remove('is-open');
      });
      }

      const parentLi = this.closest('li');
      const subUl = parentLi ? parentLi.querySelector('ul') : null;

      if (subUl) {
        subUl.classList.add('is-open');
        toggleSubmenuMode(true);
        currentlyOpenSubmenu = subUl;
        if (desktopMenuMediaQuery.matches) {
          startMainMenuHeightSync(subUl);
        }
      } else {
        toggleSubmenuMode(false);
        currentlyOpenSubmenu = null;
        stopMainMenuHeightSync();
      }
    });
  });

  // Zurück-Button (Submenüs schließen)
  if (backBtn) {
    backBtn.addEventListener('click', resetSubmenus);
  }

})();
